<template>
	<div>
		<h3>
			<q-icon class="icon-fleche"/>
			{{ title }}
		</h3>
		<p>
			Pour interpeller votre maire, c’est très simple&nbsp;: rentrez votre code postal ci-dessous et vous pourrez envoyer un email à l’adresse mail de votre mairie.
		</p>

		<div class="">
			<q-select
				@focus="onFocus"
				rounded
				outlined
				use-input
				fill-input
				hide-selected
				input-debounce="400"
				hide-dropdown-icon
				:loading="false"
				v-model="codePostal"
				@filter="onFetch"
				:options="villeList"
				label="Indiquez votre code postal"
				class="field-center search-field"/>
		</div>

		<template v-if="ville !== ''">
			<template v-if="email !== ''">
				<div class="q-my-lg">
					<div class="button bg-rouge text-white btn-main" @click="mailto">
						<div>
							<span>Envoyer un e-mail</span>
							<q-icon name="arrow_forward"/>
						</div>
					</div>
				</div>

				<p class="q-mt-lg">
					Vous pouvez contacter votre mairie via l’adresse {{ email }} et lui envoyer ce message&nbsp;:
				</p>
			</template>

			<template v-if="formulaire !== ''">
				<p class="q-mt-lg">
					Rendez-vous sur cette page : <a :href="formulaire" target="_blank">{{ formulaire }}</a> pour remplir le formulaire de contact et envoyer ce message&nbsp;:
				</p>
			</template>

			<template v-if="web !== ''">
				<p class="q-mt-lg">
					Rendez-vous sur le site web de la ville : <a :href="web" target="_blank">{{ web }}</a> pour les contacter et envoyer ce message&nbsp;:
				</p>
			</template>

			<template v-if="notFound">
				<p class="q-mt-lg">
					Nous n'avons pas trouvé votre mairie, nous vous invitons à en chercher l’adresse email sur internet et à lui envoyer ce message&nbsp;:
				</p>
			</template>

			<div class="script">
				<p v-for="(m,i) in message" :key="i">
					{{ m }}
				</p>
			</div>

		</template>
	</div>
</template>

<script>
import axios from 'axios'


export default {
	name: "ActionMaire",
	props: {
		title: String,
	},
	data() {
		return {
			codePostal: "",
			fetchedCp: "",
			receivedList: [],
			villeList: [],
			ville: "",
			email: "",
			notFound: true,
			web: "",
			formulaire: "",
			departement: "",
			commune: "",
			message: [
						"Bonjour,",
						"En France, les enfants mangent au moins 2 fois trop de viande dans les cantines scolaires par rapport aux recommandations sanitaires. C’est dangereux pour leur santé… Mais savez-vous que ça l’est également pour le climat ? La surconsommation et la surproduction de viande, notamment industrielle, ont un effet dévastateur sur la planète. L’élevage est à lui seul responsable de 14,5% des émissions mondiales de gaz à effet de serre.",
						"Il y a urgence, et vous pouvez agir. J’habite dans votre commune, et je vous demande de mettre en place plus de repas végétariens dans les cantines de nos enfants, avec 2 menus sans viande ni poisson par semaine et une option végé les autres jours. Il est également important que les menus servis à la cantine soient composés de plus de produits frais et issus de l’agriculture biologique et locale.",
						"Des villes comme Lille, Grenoble ou Mouans Sartoux sont déjà passées à l’action. Pourquoi pas notre commune ?",
						"Cordialement,"
			],
		}
	},
	beforeDestroy() {
		this.ville = ""
		this.email = ""
		this.departement = ""
		this.commune = ""
		this.formulaire = ""
		this.web = ""
		this.notFound = true
	},
	methods: {
		mailto() {
			location.href = 'mailto:' + this.email + '?subject=&body=' + encodeURIComponent(this.message.join("\n\n"))
		},

		onFocus() {
			this.$trackEvent("search", "focus code postal")
		},
		onFetch(val, update, abort) {
			val = val.toLowerCase().trim()
			if (val.length !== 5)
				return

			this.$trackEvent("search", "recherche code postal")

			this.fetchedCp = val

			// on cherche directement avec le code postal de ces 3 villes Paris, Lyon, Marseille
			if (val.match(/^750/)) {
				update( () => {
					this.villeList = [
						{
							label: "Paris (" + val + ")",
							value: "A" + val
						}
					]

					this.receivedList = [
						{
							code: "A" + val,
							nom: "Paris",
							codeDepartement: "75",
						}
					]
				})
				return
			}

			if (val.match(/^6900/)) {
				update( () => {
					this.villeList = [
						{
							label: "Lyon (" + val + ")",
							value: "A" + val
						}
					]

					this.receivedList = [
						{
							code: "A" + val,
							nom: "Lyon",
							codeDepartement: "69",
						}
					]
				})

				return
			}

			if (val.match(/^130/)) {
				update( () => {
					this.villeList = [
						{
							label: "Marseille (" + val + ")",
							value: "A" + val
						}
					]

					this.receivedList = [
						{
							code: "A" + val,
							nom: "Marseille",
							codeDepartement: "13",
						}
					]
				})

				return
			}


			axios.get("https://geo.api.gouv.fr/communes",
			{
				params: {
					codePostal: val,
					fields: "nom,code,codesPostaux,codeRegion,codeDepartement,population,centre",
					format: "json",
					geometry: "centre"
				}
			})
			.then( (r) => {
				const list = r.data
				update( () => {
					this.receivedList = list
					this.villeList = list.map( (i) => {
						return {
							label: i.nom + " ("+ i.codeDepartement +")",
							value: i.code
						}
					})
				})

			})
			.catch( (e) => {
				console.log('error', e)
				abort()
			})
		},
	},
	watch: {
		codePostal(n) {
			const va = this.receivedList.filter( (i) => i.code === n.value)
			let v = {
				code: "",
				nom: "",
				codeDepartement: "",
				/*
				codeRegion: "",
				population: "",
				centre: {coordinates: ""},
				*/
			}

			if (va.length)
				v = va[0]

/*
			let cp = v.codesPostaux

			if (cp.indexOf(this.fetchedCp) > -1)
				cp = this.fetchedCp
			else if (cp.length === 1)
				cp = cp[0]
*/
			this.commune = v.nom
			this.departement = v.codeDepartement
			this.ville = v.code

			this.email = ''
			this.web = ''
			this.formulaire = ''
			let notFound = true

			let contact = {}

			if (window.villes && window.villes[v.code]) {
				contact = window.villes[v.code]
			}


			if (contact.email) {
				if (contact.email.match(/@/))
					this.email = contact.email
				else
					this.formulaire = contact.email

				notFound = false
			}

			if (contact.web) {
				this.web = contact.web
				notFound = false
			}

			this.notFound = notFound

			this.$trackEvent("search", "choix ville")

			return n
		}
	},
}
</script>



<style lang="stylus" scoped>

@import '~quasar-variables'

.search-screen
	padding 6rem 1rem

.search-field
	flex-grow 1
	.q-field__control:before
		border 2px solid $vert
</style>